

















































































































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { PrestadorModel } from "@/models/cadastros/assistencia/PrestadorModel";
import { ServicoModel } from "@/models/commons/ServicoModel";
import ServicosAssistenciaService from "@/service/assistencia24h/ServicosAssistenciaService";
import GsModalDialog from "@/components/modal/GsModalDialog.vue";
import { tiposPessoa } from "@/models/commons/TipoPessoaModel";
import { IServicoPrestadorModel } from "@/models/cadastros/assistencia/ServicoPrestadorModel";
import { FiltroPrestadorModel } from "@/models/cadastros/assistencia/FiltroPrestadorModel";
import { ResultadoFiltroModel } from "@/models/cadastros/assistencia/ResultadoFiltroModel";
import { PaginationModel } from "@/models/commons/PaginationModel";
import { CONTA_CORRENTE } from "../../../../models/commons/TipoContaBancariaModel";

import {
  TipoServicoModel,
  tipoServicoVeicularList,
} from "../../../../models/commons/TipoServicoModel";
import {
  TipoVeiculoModel,
  tiposVeliculoList,
} from "../../../../models/commons/TipoVeiculoModel";
import {
  EstadosCidades,
  EstadosCidadesResponse,
} from "@/models/estados-cidades";
import axios, { AxiosResponse } from "axios";
import { filtroCadastrosStore } from "@/store/cadastros/FiltroCadastros";

@Component({
  components: {
    GsModalDialog,
  },
})
export default class ListaPrestadores extends Vue {
  cabecalhoPrestadores = [
    { text: "CPF / CNPJ", value: "cpfCnpj", width: "20%" },
    { text: "Nome / Razão Social", value: "nomeRazaoSocial", width: "20%" },
    {
      text: "Categoria / Tipo serviço",
      value: "precosServico",
      sortable: false,
      width: "25%",
    },
    { text: "Região de atendimento", value: "regiaoAtendimento", width: "20%", sortable: false },
    { text: "Ações", value: "actions", width: "15%", sortable: false },
    { text: 'Ativo', value: 'ativo', width: "15%", sortable: false }
  ];

  dialogType = "";
  showDialog = false;
  showDialogAtivarInativar = false;
  dialogTitle = "";
  dialogMessage = "";

  switchPrestador = true;

  tiposServicos = tipoServicoVeicularList;
  tiposVeiculo = tiposVeliculoList;

  prestadorExclusao: PrestadorModel = {
    flagCadastroCPOM: false,
    contaBancaria: {
      codigoBanco: "",
      numeroAgencia: "",
      numeroConta: "",
      contaPrincipal: false,
      cpfCnpjTitular: "",
      nomeTitular: "",
      prestadorTitular: false,
      tipoPessoa: "FISICA",
      tipoContaBancaria: CONTA_CORRENTE
    }
  };

  prestadorAtivo = {
    id: 0,
    ativo: true
  };

  filtro : FiltroPrestadorModel = { 
    cpfCnpjFiltro: "",
    nomeFiltro: "",
    servicoFiltro: undefined,
    categoriaFiltro: undefined,
    estado: undefined,
    cidade: "",
    paginacao: { 
      itemsPerPage: 15,
      page: 1,
      itemsLength: 0
    }
  };

  estados: EstadosCidades[] = [];
  cidades: string[] = [];
  estado: EstadosCidades = {cidades: [], sigla: "", nome: ""};
  cidade: string = "";

  resultadoFiltroModel: ResultadoFiltroModel = {
    content: []
  };
  loading = false;
  
  mounted() {
    axios
      .get<EstadosCidadesResponse>("/administrativo/json/estados-cidades.json")
      .then((resp) => (this.estados = resp.data.estados));

    this.filtro = filtroCadastrosStore.filtroAtualPrestadores || this.filtro as FiltroPrestadorModel; // read state do filtro

    if (this.filtro == filtroCadastrosStore.filtroAtualPrestadores) {
      this.filtrar();
    }    
  }

  @Watch("filtro.estado")
  selectCities() {
    this.cidades = [];
    if (this.filtro.estado && this.estados.length > 0) {
      this.cidades = this.estados.filter(
        (v) => v.sigla === this.filtro.estado.sigla
      )[0].cidades;
    } else {
      if (this.filtro.estado) {
        this.cidades = this.filtro.estado.cidades;
      } else {
        this.filtro.estado = undefined;
        this.filtro.cidade = undefined;
      }
    }
  }

  @Watch("filtro.paginacao.page")
  @Watch("filtro.paginacao.itemsPerPage")
  observarPaginacao() {
    if (this.filtroPreenchido()) {
      this.getData();
    }
  }

  excluirPrestador(prestador: PrestadorModel) {
    this.prestadorExclusao = prestador;
    this.openDialog(
      "confirm",
      "Confimação de exclusão",
      `Deseja realmente excluir o prestador ${prestador.nomeRazaoSocial} ?`
    )
  }

  habilitarDesabilitarPrestador(prestador: PrestadorModel) {
    this.prestadorAtivo = {
      id: prestador.id ?? 0,
      ativo: prestador.ativo ?? true
    };

    if (!this.prestadorAtivo.ativo){
      this.openDialogAtivarInativar(
        "confirm",
        "Confirmar inativação",
        `Deseja inativar o prestador ${prestador.nomeRazaoSocial} ?`
      );
    } else {
      this.openDialogAtivarInativar(
        "confirm",
        "Confirmar ativação",
        `Deseja ativar o prestador ${prestador.nomeRazaoSocial} ?`
      );
    }
  }

  ativarInativarPrestador() {
    if (this.prestadorAtivo.ativo == false) {
      ServicosAssistenciaService.inativarPrestador(this.prestadorAtivo.id).then(
        res => {
          this.closeDialog();
          this.openDialogAtivarInativar(
            "success",
            "Sucesso",
            "Prestador inativado com sucesso."
          );
        },
        err => {
          this.closeDialog();
          this.openDialogAtivarInativar(
            "error",
            "Erro",
            "Ocorreu um erro ao inativar o prestador."
          );
          console.error(err);
        }
      );
    } else {
      ServicosAssistenciaService.ativarPrestador(this.prestadorAtivo.id).then(
        res => {
          this.closeDialog();
          this.openDialogAtivarInativar(
            "success",
            "Sucesso",
            "Prestador ativado com sucesso."
          );
        },
        err => {
          this.closeDialog();
          this.openDialogAtivarInativar(
            "error",
            "Erro",
            "Ocorreu um erro ao ativar o prestador."
          );
          console.error(err);
        }
      )
    }
  }

  closeDialogAtivarInativar(){
    if (this.resultadoFiltroModel.content){
      const index = this.resultadoFiltroModel.content?.findIndex(item => {
        return item.id == this.prestadorAtivo.id;
      });

      this.resultadoFiltroModel.content[index].ativo = !this.prestadorAtivo.ativo;
      this.closeDialog();
    }
  }

  excluir() {
    if (this.prestadorExclusao?.id) {
      ServicosAssistenciaService.deletePrestadorAssistencia(
        this.prestadorExclusao?.id
      ).then(
        (res) => {
          this.closeDialog();
          this.openDialog(
            "success",
            "Sucesso",
            "Prestador excluído com sucesso."
          );
          this.filtrar();
        },
        (err) => {
          this.closeDialog();
          this.openDialog(
            "error",
            "Erro",
            "Ocorreu um erro ao excluir o prestador."
          );
          console.error(err);
        }
      );
    }
  }

  filtrar() {
    if (!this.filtroPreenchido()) {
      this.openDialog(
        "error",
        "Informe o filtro",
        "Informe pelo menos um campo no filtro."
      );

      this.resultadoFiltroModel.content = [];
    } else {
        this.getData();
        filtroCadastrosStore.SET_FILTRO_PRESTADORES(this.filtro); // save do state do filtro
      }
  }

  getData() {
    this.loading = true;
    ServicosAssistenciaService.pesquisarPrestadorAssistencia(this.filtro).then(
      (res) => {
        this.resultadoFiltroModel.content = res.data.content.map((c: any) => {
          return {
            id: c.id,
            tipoPessoa: tiposPessoa.filter((t) => {
              return t.nome == c.tipoPessoa;
            })[0],
            tipoPessoaString: c.tipoPessoa.substring(0, 1),
            cpfCnpj: c.cpfCnpj,
            nomeRazaoSocial: c.nome,
            email: c.email,
            flagCadastroCPOM: c.flagPrestadorCadastradoCPOM,
            regiaoAtendimento: c.precosServico.map((preco: any) => preco.cidade).join(", "),
            ativo: c.ativo,
            precosServico: c.precosServico?.map((s: any) => {
              return {
                tipoServico: tipoServicoVeicularList.find(
                  (t) => t.name == s.tipoServico
                ),
                tipoVeiculo: tiposVeliculoList.find(
                  (t) => t.name == s.tipoVeiculo
                ),
                valorKmExcedido: s.valorKmExcedido
                  ? s.valorKmExcedido.toString()
                  : "0",
                valorMeiaSaida: s.valorMeiaSaida
                  ? s.valorMeiaSaida.toString()
                  : "0",
                valorSaida: s.valorSaida ? s.valorSaida.toString() : "0",
                kmSaida: s.kmSaida ? s.kmSaida.toString() : "0",               
              } as IServicoPrestadorModel;
            })
          } as PrestadorModel;
        });
        this.filtro.paginacao.itemsLength = res.data.totalElements;
        this.loading = false;
      },
      (err) => {
        console.error(err);
        this.loading = false;
      }
    );
  }

  private filtroPreenchido(): boolean {
    return (!!this.filtro.cpfCnpjFiltro && !!this.filtro.cpfCnpjFiltro.trim()) ||
      (!!this.filtro.nomeFiltro && !!this.filtro.nomeFiltro.trim()) ||
      (!!this.filtro.servicoFiltro) ||
      (!!this.filtro.categoriaFiltro) ||
      (!!this.filtro.estado);
  }

  private openDialog(dialogType: string, title: string, message: string) {
    this.dialogType = dialogType;
    this.dialogTitle = title;
    this.dialogMessage = message;
    this.showDialog = true;
  }

  private openDialogAtivarInativar(dialogType: string, title: string, message: string) {
    this.dialogType = dialogType;
    this.dialogTitle = title;
    this.dialogMessage = message;
    this.showDialogAtivarInativar = true;
  }

  public closeDialog(): void {
    this.showDialog = false;
    this.showDialogAtivarInativar = false;
  }

  get btnColor() {
    let color: string;
    switch (this.dialogType) {
      case "success":
        color = "#00CD96";
        break;
      case "error":
        color = "error";
        break;
      case "confirm":
        color = "error";
        break;
      default:
        color = "primary";
        break;
    }
    return color;
  }

  get btnText() {
    let text: string;
    switch (this.dialogType) {
      case "success":
        text = "Ok, entendi";
        break;
      case "error":
        text = "Fechar";
        break;
      case "confirm":
        text = "Cancelar";
        break;
      default:
        text = "Ok, entendi";
        break;
    }
    return text;
  }

  get dialogImg() {
    return `${this.dialogType}.png`;
  }
}
